import { useNavigate } from "react-router-dom";

const GoToLogin = (props = {}) => {
  const { loading } = props;
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/login", { replace: true });
  };

  return (
    <p className="auth-switch-text">
      Already have an account?{" "}
      <button
        type="button"
        className="auth-switch-button"
        disabled={loading}
        onClick={handleClick}
      >
        Login
      </button>
    </p>
  );
};

export default GoToLogin;
